import { render, staticRenderFns } from "./manageRequest.vue?vue&type=template&id=2b641408&scoped=true&"
import script from "./manageRequest.vue?vue&type=script&lang=js&"
export * from "./manageRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b641408",
  null
  
)

export default component.exports